// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;700&family=Roboto:wght@400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Changa:wght@500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BASE COLOR
------------------------------------------------------------*/
/* DISPLAY SETTING
------------------------------------------------------------*/
/* OTHER SETTING
------------------------------------------------------------*/
[data-v-7653fc8a]:root {
  font-size: calc(14.5px + 1.5 * (100vw - 1440px) / 480);
  --cx: 0;
  --cy: 0;
  --vw: 100vw;
  --vh: 100vh;
  --screen: 0px;
  --size: 32px;
}
@media screen and (min-width: 1920px) {
[data-v-7653fc8a]:root {
    font-size: 16px;
}
}
@media screen and (max-width: 1023px) {
[data-v-7653fc8a]:root {
    font-size: 14px;
    --size: 16px;
}
}
@media screen and (max-width: 769px) {
[data-v-7653fc8a]:root {
    font-size: 13.5px;
    --size: 10px;
}
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 100;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 200;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 300;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 400;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Medium");
  font-weight: 500;
}
@font-face {
  font-family: "Yu Gothic";
  src: local("Yu Gothic Bold");
  font-weight: bold;
}
.nav-enter-active[data-v-7653fc8a],
.nav-leave-active[data-v-7653fc8a] {
  transition: opacity 0.5s cubic-bezier(0.65, 0, 0.35, 1);
}
.nav-enter-from[data-v-7653fc8a],
.nav-leave-to[data-v-7653fc8a] {
  opacity: 0;
}
header[data-v-7653fc8a] {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  padding: 1.2rem calc(var(--size) + 2vw);
  display: grid;
  grid-template-columns: auto auto;
  z-index: 1000;
}
@media screen and (max-width: 769px) {
header[data-v-7653fc8a] {
    background: #fff;
    padding: 1.1rem calc(var(--size) + 2vw);
}
}
header .logo[data-v-7653fc8a] {
  width: 14rem;
  justify-self: flex-start;
}
@media screen and (max-width: 769px) {
header .logo[data-v-7653fc8a] {
    width: 13rem;
}
}
header .logo img[data-v-7653fc8a] {
  width: 100%;
}
header .trg[data-v-7653fc8a] {
  position: fixed;
  top: 0;
  right: 0;
  width: 6.4rem;
  height: 6.4rem;
  cursor: pointer;
  border-radius: 0 0 0 1rem;
  overflow: hidden;
  z-index: 10;
}
@media screen and (max-width: 769px) {
header .trg[data-v-7653fc8a] {
    width: var(--head);
    height: var(--head);
}
}
header .trg[data-v-7653fc8a]:before, header .trg[data-v-7653fc8a]:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #c8141e;
  z-index: -1;
}
header .trg[data-v-7653fc8a]:after {
  width: 0;
  left: auto;
  right: 0;
  background: rgb(36.1156069364, 34.8843930636, 34.8843930636);
  transition: all 320ms cubic-bezier(0.65, 0, 0.35, 1);
}
header .trg[data-v-7653fc8a]:hover:after {
  width: 100%;
  left: 0;
  right: auto;
}
header .trg.active[data-v-7653fc8a]:after {
  width: 100%;
}
header .trg.active[data-v-7653fc8a]:hover:after {
  background: #585555;
}
header .trg.active i[data-v-7653fc8a] {
  width: 0;
}
header .trg.active i[data-v-7653fc8a]:first-of-type, header .trg.active i[data-v-7653fc8a]:last-of-type {
  width: 40%;
  top: 50%;
}
header .trg.active i[data-v-7653fc8a]:first-of-type {
  transform: translate(-50%) rotate(45deg);
}
header .trg.active i[data-v-7653fc8a]:last-of-type {
  transform: translate(-50%) rotate(-45deg);
}
header .trg i[data-v-7653fc8a] {
  width: 33%;
  height: 1px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%);
  transition: all 320ms cubic-bezier(0.65, 0, 0.35, 1);
}
header .trg i[data-v-7653fc8a]:first-of-type {
  top: calc(50% - 0.5rem);
}
header .trg i[data-v-7653fc8a]:last-of-type {
  top: calc(50% + 0.5rem);
}
header .fix[data-v-7653fc8a] {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #000;
}
header nav[data-v-7653fc8a] {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #c8141e;
  background-image: url(./images/common/nav_tex_2x.webp);
  background-size: 200px;
  background-repeat: repeat;
  z-index: 9;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  animation: bgRepeat-7653fc8a 4000ms linear infinite;
}
@keyframes bgRepeat-7653fc8a {
0% {
    background-position: 0 0;
}
100% {
    background-position: -200px -100px;
}
}
header nav .logo[data-v-7653fc8a] {
  position: absolute;
  top: 1.2rem;
  left: calc(var(--size) + 2vw);
  z-index: 10;
}
header nav ul[data-v-7653fc8a] {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 2.4vmin;
  grid-row-gap: 2.4vmin;
}
@media screen and (max-width: 1023px) {
header nav ul[data-v-7653fc8a] {
    grid-template-columns: repeat(1, 1fr);
}
}
header nav ul li[data-v-7653fc8a] {
  line-height: 1;
}
header nav ul li a[data-v-7653fc8a] {
  font-size: 7.2vmin;
  color: #fff;
  fill: #fff;
  display: inline-flex;
  align-items: center;
  position: relative;
  padding: 0.4rem;
  z-index: 1;
}
@media screen and (max-width: 1023px) {
header nav ul li a[data-v-7653fc8a] {
    font-size: 6.4vmin;
}
}
header nav ul li a[data-v-7653fc8a]:before {
  content: "";
  width: 0;
  height: 100%;
  background: #c88f14;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  transition: width 320ms cubic-bezier(0.65, 0, 0.35, 1);
  z-index: -1;
}
header nav ul li a[data-v-7653fc8a]:hover:before {
  width: 100%;
  left: 0;
  right: auto;
}
header nav ul li a svg[data-v-7653fc8a] {
  width: 7.2vmin;
  height: 7.2vmin;
  display: inline-block;
  margin: 0 0 0 0.8vmin;
}
header nav .sns[data-v-7653fc8a] {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
header nav .sns[data-v-7653fc8a]:before {
  content: attr(data-eng);
  color: #fff;
  position: absolute;
  top: -1rem;
  left: 50%;
  transform: translate(-50%, -100%);
  white-space: nowrap;
  animation: jumpText-7653fc8a 800ms cubic-bezier(0.65, 0, 0.35, 1) infinite;
}
@keyframes jumpText-7653fc8a {
0%, 100% {
    transform: translate(-50%, -100%);
}
60% {
    transform: translate(-50%, -120%);
}
}
header nav .sns a[data-v-7653fc8a] {
  width: 4rem;
  height: 4rem;
  background: #c88f14;
  border-right: rgb(162.9090909091, 116.48, 16.2909090909) 1px solid;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}
header nav .sns a[data-v-7653fc8a]:hover {
  background: rgb(162.9090909091, 116.48, 16.2909090909);
}
header nav .sns a[data-v-7653fc8a]:last-of-type {
  border: none;
}
header nav .sns a svg[data-v-7653fc8a] {
  width: 1.4rem;
  height: 1.4rem;
  fill: #fff;
}
header nav .sns a.ln svg[data-v-7653fc8a] {
  width: 1.72rem;
  height: 1.72rem;
}`, "",{"version":3,"sources":["webpack://./src/scss/module/_module.scss","webpack://./headers.vue","webpack://./src/js/components/headers.vue"],"names":[],"mappings":"AAGA;6DAAA;AAcA;6DAAA;AAOA;6DAAA;AAEA;EACC,sDAAA;EACA,OAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACC,aAAA;EACA,YAAA;ACjBF;ADkBC;AARD;IASE,eAAA;ACfA;AACF;ADgBC;AAXD;IAYE,eAAA;IACE,YAAA;ACbF;AACF;ADcC;AAfD;IAgBE,iBAAA;IACE,YAAA;ACXF;AACF;ADsGA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACnGD;ADqGA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACnGD;ADqGA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACnGD;ADqGA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACnGD;ADqGA;EACC,wBAAA;EACA,8BAAA;EACA,gBAAA;ACnGD;ADqGA;EACC,wBAAA;EACA,4BAAA;EACA,iBAAA;ACnGD;AC9DA;;EAEE,uDAAA;ADgEF;AC9DA;;EAEE,UAAA;ADiEF;AC/DA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,uCAAA;EACA,aAAA;EACA,gCAAA;EACA,aAAA;ADkEF;ACjEE;AATF;IAUI,gBFVI;IEWJ,uCAAA;ADoEF;AACF;ACnEE;EACE,YAAA;EACA,wBAAA;ADqEJ;ACpEI;AAHF;IAII,YAAA;ADuEJ;AACF;ACtEI;EACE,WAAA;ADwEN;ACrEE;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;ADuEJ;ACtEI;AAVF;IAWI,kBAAA;IACA,mBAAA;ADyEJ;AACF;ACxEI;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBFjDC;EEkDD,WAAA;ADyEN;ACvEI;EACE,QAAA;EACA,UAAA;EACA,QAAA;EACA,4DAAA;EACA,oDAAA;ADyEN;ACtEM;EACE,WAAA;EACA,OAAA;EACA,WAAA;ADwER;ACpEM;EACE,WAAA;ADsER;ACnEQ;EACE,mBFzED;AC8IT;AClEM;EACE,QAAA;ADoER;ACnEQ;EAEE,UAAA;EACA,QAAA;ADoEV;AClEQ;EACE,wCAAA;ADoEV;AClEQ;EACE,yCAAA;ADoEV;AChEI;EACE,UAAA;EACA,WAAA;EACA,gBFzFE;EE0FF,kBAAA;EACA,QAAA;EACA,SAAA;EACA,0BAAA;EACA,oDAAA;ADkEN;ACjEM;EACE,uBAAA;ADmER;ACjEM;EACE,uBAAA;ADmER;AC/DE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,gBAAA;ADiEJ;AC/DE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,yBFzHG;EE0HH,sDAAA;EACA,sBAAA;EACA,yBAAA;EACA,UAAA;EFnFH,aAAA;EACA,mBAAA;EACA,8BAHiC;EAIhC,iBAAA;EEkFE,mBAAA;EACA,uBAAA;EACA,mDAAA;ADoEJ;ACnEI;AACE;IACE,wBAAA;ADqEN;ACnEI;IACE,kCAAA;ADqEN;AACF;ACnEI;EACE,kBAAA;EACA,WAAA;EACA,6BAAA;EACA,WAAA;ADqEN;ACnEI;EACE,aAAA;EACA,qCAAA;EACA,wBAAA;EACA,qBAAA;ADqEN;ACpEM;AALF;IAMI,qCAAA;ADuEN;AACF;ACtEM;EACE,cAAA;ADwER;ACvEQ;EACE,kBAAA;EACA,WFxJF;EEyJE,UFzJF;EE0JE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;ADyEV;ACxEU;AATF;IAUI,kBAAA;AD2EV;AACF;AC1EU;EACE,WAAA;EACA,QAAA;EACA,YAAA;EACA,mBFzKN;EE0KM,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,sDAAA;EACA,WAAA;AD4EZ;ACzEY;EACE,WAAA;EACA,OAAA;EACA,WAAA;AD2Ed;ACxEU;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;AD0EZ;ACrEI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,qCAAA;ADuEN;ACtEM;EACE,uBAAA;EACA,WFvMA;EEwMA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;EACA,mBAAA;EACA,0EAAA;ADwER;ACvEQ;AACE;IACE,iCAAA;ADyEV;ACvEQ;IACE,iCAAA;ADyEV;AACF;ACtEM;EACE,WAAA;EACA,YAAA;EACA,mBF7NF;EE8NE,kEAAA;EFrLP,aAAA;EACA,mBAAA;EACA,8BAHiC;EAIhC,iBAAA;EEoLM,mBAAA;EACA,uBAAA;AD2ER;AC1EQ;EACE,sDAAA;AD4EV;AC1EQ;EACE,YAAA;AD4EV;AC1EQ;EACE,aAAA;EACA,cAAA;EACA,UFxOF;ACoTR;ACzEU;EACE,cAAA;EACA,eAAA;AD2EZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
